module.exports = __webpack_public_path__ + "img/blockGq2-2.bdaa5c60.svg";